import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { PaymentMethod } from "../../model/payment-method.model";
import { PaymentMethodType } from "../../model/payment-method.enum";
import { take, takeUntil } from "rxjs/operators";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { Lookup } from "projects/sepidz-web-framework/src/lib/models";
import { Subscription } from "rxjs";
import { SoftWareLicenseKind } from "projects/sepidz-web-framework/src/lib/models/license-information.model";
import { log } from "console";

@Component({
  selector: "ngx-payment-method-form.component",
  templateUrl: "./payment-method-form.component.html",
  styleUrls: ["./payment-method-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentMethodFormComponent extends BaseFormComponent<PaymentMethod> {
  paymentMethodType = PaymentMethodType;
  deactivateSave: boolean = false;
  paymentMethodTypeItems: Lookup[];
  PaymentMethodTypeSubscription: Subscription;
  ipPattern: string = "^(?:[0-9]{1,3}.){3}[0-9]{1,3}$";
  portPattern: string = "^[0-9]{1,5}$";
  hasRahkaran: boolean = false;

  constructor(private lookupservice: LookupService, protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }

  ngAfterViewInit(): void {
    this.FillData();
    this.hasRahkaranSetting();
  }

  async FillData() {
    const info = this.accountService.authService.currentInformation();
    if (info.BranchingLightEnabled || info.BranchingAdvancedEnabled) {
      const hasBranchCommunication = JSON.parse(localStorage.getItem("HasBranchCommunication"));
      if (hasBranchCommunication == null) {
        this.httpCommonService
          .getList(`Branch/HasBranchCommunication/${this.accountService.authService.currentBranchId}`)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            async (hbc: boolean) => {
              if (hbc === true) {
                this.sts.showDialog(
                  this.translate("ClientApp.FrontOffice.Financial.PaymentMethod.HasBranchCommunication"),
                  this.translate("ClientApp.FrontOffice.Financial.PaymentMethod.Attention")
                );
                this.deactivateSave = true;
              }
            },
            (error) => this.getFailedHelper(error)
          );
      } else if (hasBranchCommunication) {
        this.sts.showDialog(
          this.translate("ClientApp.FrontOffice.Financial.PaymentMethod.HasBranchCommunication"),
          this.translate("ClientApp.FrontOffice.Financial.PaymentMethod.Attention")
        );
        this.deactivateSave = true;
      }
    }
    if (this.model.IsActive === undefined) this.model.IsActive = true;
    if (!this.model.PaymentMethodTypeId) {
      this.lookupservice
        .getLookupbyCategory("SALE", "PaymentMethodType")
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(async (data) => {
          this.paymentMethodTypeItems = data;
          const cashData = data.find((x) => x.Code == this.paymentMethodType.Cash);
          this.model.PaymentMethodTypeId = cashData?.Id;
          this.model.PaymentMethodTypeCode = cashData?.Code;
          this.model.PaymentMethodTypeTitle = cashData?.Title;
          this.setValue("PaymentMethodTypeId", cashData?.Id);
          this.setValue("PaymentMethodTypeCode", cashData?.Code);
          this.setValue("PaymentMethodTypeTitle", cashData?.Title);
          setTimeout(() => {
            this.formGroup.controls["PaymentMethodTypeId"].valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((id) => {
              this.onPaymentMethodTypeIdChanges(id);
            });
          }, 500);
        });
    } else if (this.model.PaymentTerminalProviderId) {
      this.model.PaymentMethodTypeCode = this.paymentMethodType.Pos;
    }

    setTimeout(() => {
      this.setValue("IsWebService", this.model?.IsWebService);
      this.formGroup.controls["IsWebService"].valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value) => {
        this.showHideIpAndPort(value);
      });
    }, 200);
  }
  setColumnAttribute() {
    super.setColumnAttribute();
    if (!this.model) return;
    const currentInfo = this.accountService.authService.currentInformation();
    const accountingInstalled =
      currentInfo.AccountingKind === SoftWareLicenseKind.AccountingAdvancedWeb ||
      currentInfo.AccountingKind === SoftWareLicenseKind.AccountingToAdvancedWeb ||
      currentInfo.AccountingKind === SoftWareLicenseKind.AccountingWeb;
    const isPos = this.model.PaymentMethodTypeCode === PaymentMethodType.Pos;
    const isTabletPos = this.model.PaymentMethodTypeCode === PaymentMethodType.TabletPos;
    const isCash = this.model.PaymentMethodTypeCode === PaymentMethodType.Cash;
    const isCheck = this.model.PaymentMethodTypeCode === PaymentMethodType.Check;
    const isInternet = this.model.PaymentMethodTypeCode === PaymentMethodType.Internet;
    const controlsNameToShowInPosMode = [
      "Ip",
      "Port",
      "PosTimeOut",
      "IsMultMierchantPos",
      "PaymentTerminalProviderId",
      "UserName",
      "Password",
      "IsWebService",
      "CashId",
    ];
    this.orignalColumns.forEach((x) => {
      if (controlsNameToShowInPosMode.includes(x.name)) {
        x.formVisible = isPos;
        x.required = isPos && x.name !== "IsMultMierchantPos";
      }

      if (x.name === "Ip") x.patternKey = this.ipPattern;

      if (x.name === "Port") x.patternKey = this.portPattern;

      if (x.name === "PaymentTerminalProviderId") x.formVisible = isTabletPos || isPos;

      if (x.name === "IBANCode") x.formVisible = isPos || isTabletPos || isInternet;

      if (x.name === "IsMultiMerchantPos") x.formVisible = isPos || isTabletPos || isInternet;

      if (x.name === "TerminalId") x.formVisible = isPos || isTabletPos || isInternet;

      if (x.name.includes("UserName")) x.required = false;

      if (x.name.includes("Password")) {
        x.textType = "password";
        x.required = false;
      }
      if (x.name.includes("CashId")) {
        x.required = false;
        x.formVisible = false;
      }
      if (x.name === "CashId" && this.hasRahkaran) x.formVisible = true;
      if (
        !accountingInstalled &&
        (x.name === "InterfaceAccountSubLedgerId" || x.name === "PaymentMethodTypeSubLedgerId" || x.name === "PaymentMethodTypeDetailLedgerId")
      ) {
        x.formVisible = false;
      }

      if (!accountingInstalled && x.name === "TrsConcernId") {
        x.formVisible = false;
      }
    });

    this.columns = this.orignalColumns.filter(
      (f) => ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
    );
    this.columns = this.columns.sort((a, b) => a.order - b.order);
    this.cd.markForCheck();
  }

  beforupdate(): void {
    if (this.model.PaymentMethodTypeCode !== PaymentMethodType.Pos) {
      this.formGroup.controls["Ip"].setValue("");
      this.formGroup.controls["Port"].setValue("");
    }
  }

  addControl() {
    if (!this.currentrow || !this.currentrow.Id) {
      this.model.IsActive = true;
      this.setValue("IsActive", true);
    }
    if (this.model.PaymentMethodTypeCode === this.paymentMethodType.Pos)
      this.setValue("PaymentTerminalProviderId", this.model.PaymentTerminalProviderId, true);
    this.setColumnAttribute();
    this.setColumnNumber;
    this.cd.markForCheck();
  }

  isValid() {
    if (this.formGroup.controls["PaymentMethodTypeId"].dirty && !this.formGroup.controls["PaymentMethodTypeId"]?.value) {
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.Financial.PaymentMethod.SellNotEntered"),
        this.translate("ClientApp.FrontOffice.Financial.PaymentMethod.Error")
      );
      this.selectorService.submitted$.next(true);
      return false;
    }
    if (!this.formGroup.controls["Title"].value) {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Financial.PaymentMethod.Error"),
        this.translate("ClientApp.FrontOffice.Financial.PaymentMethod.TitleNotEntered")
      );
      return false;
    }
    if (this.model.PaymentMethodTypeCode === this.paymentMethodType.Pos) {
      if (!this.formGroup.controls["PaymentTerminalProviderId"]?.value) {
        this.sts.showToast(
          "danger",
          this.translate("ClientApp.FrontOffice.Financial.PaymentMethod.Error"),
          this.translate("ClientApp.FrontOffice.Financial.PaymentMethod.ProviderNotEntered")
        );
        return false;
      }
      if (!this.formGroup.controls["Ip"].value) {
        this.sts.showToast(
          "danger",
          this.translate("ClientApp.FrontOffice.Financial.PaymentMethod.Error"),
          this.translate("ClientApp.FrontOffice.Financial.PaymentMethod.IPNotEntered")
        );
        return false;
      }
      if (!this.formGroup.controls["PosTimeOut"].value) {
        this.sts.showToast(
          "danger",
          this.translate("ClientApp.FrontOffice.Financial.PaymentMethod.Error"),
          this.translate("ClientApp.FrontOffice.Financial.PaymentMethod.PosWaitTimeNotEntered")
        );
        return false;
      }
      if (!this.formGroup.controls["Port"].value) {
        this.sts.showToast(
          "danger",
          this.translate("ClientApp.FrontOffice.Financial.PaymentMethod.Error"),
          this.translate("ClientApp.FrontOffice.Financial.PaymentMethod.PortNotEntered")
        );
        return false;
      }
    }
    return true;
  }
  private onPaymentMethodTypeIdChanges(id: any): void {
    const findData = this.paymentMethodTypeItems.find((item) => item.Id === id);
    if (findData) {
      if (this.formGroup.controls["Ip"]) {
        this.formGroup.controls["Ip"].clearValidators();
        this.formGroup.controls["Ip"].setErrors(null);
        this.formGroup.controls["Ip"].updateValueAndValidity();
      }
      if (this.formGroup.controls["Port"]) {
        this.formGroup.controls["Port"].clearValidators();
        this.formGroup.controls["Port"].setErrors(null);
        this.formGroup.controls["Port"].updateValueAndValidity();
      }
      if (this.formGroup.controls["PosTimeOut"]) {
        this.formGroup.controls["PosTimeOut"].clearValidators();
        this.formGroup.controls["PosTimeOut"].setErrors(null);
        this.formGroup.controls["PosTimeOut"].updateValueAndValidity();
      }
      this.model.PaymentMethodTypeCode = findData.Code;
      this.model.PaymentMethodTypeTitle = findData.Title;
      if (this.formGroup.controls["PaymentTerminalProviderId"]) {
        this.formGroup.controls["PaymentTerminalProviderId"].clearValidators();
        this.formGroup.controls["PaymentTerminalProviderId"].setErrors(null);
        this.formGroup.controls["PaymentTerminalProviderId"].updateValueAndValidity();
      }
      if (findData.Code !== this.paymentMethodType.Pos) {
        this.model.PaymentTerminalProviderId = null;
        if (this.formGroup.controls["PaymentTerminalProviderId"])
          this.setValue("PaymentTerminalProviderId", this.model.PaymentTerminalProviderId, false);
      }
      if (this.model.PaymentMethodTypeCode === this.paymentMethodType.Pos)
        this.setValue("PaymentTerminalProviderId", this.model.PaymentTerminalProviderId, true);
      else this.setValue("PaymentTerminalProviderId", this.model.PaymentTerminalProviderId, false);
      this.setColumnAttribute();
      this.isValid();
      this.cd.markForCheck();
    }
  }

  showHideIpAndPort(value: boolean) {
    this.orignalColumns.forEach((x) => {
      if (x.name === "Ip" || x.name === "Port" || x.name === "PosTimeOut") {
        x.formVisible = !value && this.model.PaymentMethodTypeCode === PaymentMethodType.Pos;
        if (value) {
          this.formGroup.controls[x.name].clearValidators();
          this.formGroup.controls[x.name].setErrors(undefined);
        }
      }
    });
    this.columns = this.orignalColumns.filter(
      (f) => ((!f.areaName || f.areaName === "default") && f.formVisible) || (f.DetailControlModels && f.DetailControlModels[f.name].length > 0)
    );
    this.columns = this.columns.sort((a, b) => a.order - b.order);
    this.cd.markForCheck();
  }
  hasRahkaranSetting() {
    this.httpCommonService
      .get("Rahkaran/GetRahkaranSetting")
      .pipe(take(1))
      .subscribe((x: boolean) => {
        this.hasRahkaran = x;
      });
  }
}
